import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { TAX_FREE_THRESHOLD } from '@/api/payments/paymentsService'
import { AppDialog } from '@/components/AppDialog'
import { Divider } from '@/components/Divider'
import UniteIcon from '@/components/icons/pkg-unite.svg?react'
import { Button } from '@/components/ui/button'

interface UniteConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (shouldShrink?: boolean) => void
  isLoading?: boolean
  isFreeUnite?: boolean
  isUSWarehouse?: boolean
  packageCount?: number
}

export const UniteConfirmationDialog: FC<UniteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  isFreeUnite,
  isUSWarehouse = false,
}) => {
  const { t } = useTranslation()
  return (
    <AppDialog isOpen={isOpen} onOpenChange={onClose} className='!max-w-lg'>
      <div className='flex flex-col items-center gap-6'>
        <div className='flex flex-col items-center gap-4'>
          <div className='h-6 w-6'>
            <UniteIcon className='text-icon-primary h-full w-full' />
          </div>
          <h2 className='text-text-primary text-center text-lg font-medium'>{t('unite.uniteTitle')}</h2>
        </div>

        <div className='flex flex-col items-center gap-6'>
          <div className='text-text-secondary text-center text-sm leading-5'>
            <p className='mb-1'>{t('unite.uniteDesc1')}</p>
            <p className='mb-1'>{t('unite.uniteDesc2')}</p>
            <p>{t('unite.uniteDesc3', { threshold: TAX_FREE_THRESHOLD })}</p>
            {isUSWarehouse && <p className='font-medium'>{t('unite.uniteDesc4')}</p>}
          </div>

          <div className='bg-button-primary-selected-segment text-text-secondary rounded-full px-3 py-2'>
            <p className='text-center text-xs'>{isFreeUnite ? t('unite.freeUniteMessage') : t('unite.paidUniteMessage')}</p>
          </div>
          <p className='text-text-secondary text-xs'>{t('unite.uniteCancelHint')}</p>
        </div>
        <Divider />
        <div className='flex items-center justify-center gap-6'>
          {isUSWarehouse ? (
            <>
              <Button variant='outline' className='font-normal' size='lg' disabled={isLoading} onClick={() => onConfirm(false)}>
                {t('unite.uniteOnly')}
              </Button>
              <Button disabled={isLoading} onClick={() => onConfirm(true)} size='lg'>
                {t('unite.uniteAndShrink')}
              </Button>
            </>
          ) : (
            <Button disabled={isLoading} onClick={() => onConfirm()} size='lg'>
              {t('unite.uniteConfirmButton')}
            </Button>
          )}
        </div>
      </div>
    </AppDialog>
  )
}
